import * as React from "react";
import { CardContent } from "../../../components/antd/card/CardContent";
import { CodeEditor } from "../../group/identityMatcher/codeEditor";
import { useCpFormContext } from "../../../components/form/useCpFormContext";
import { formSet, formSetValue, useCpFormValue } from "../../gvc/testNewForm/utils";
import { CpSwitch } from "../../gvc/testNewForm/CpSwitch";
import { CpLabel } from "../../gvc/testNewForm/CpLabel";
import { CpFormItem } from "../../gvc/testNewForm/CpFormItem";
import { CpErrorWarning } from "../../gvc/testNewForm/CpErrorWarning";
import { store } from "../../../store";
import { CpTooltip } from "../../gvc/testNewForm/CpTooltip";
import { ImportButtonRaw, DropZone } from "../../../components/import";
import { SecretCodeEditorObfuscated } from "./SecretCodeEditorObfuscated";

interface Props {}
export const SecretDataOpaque: React.FC<Props> = ({}) => {
  const { id } = useCpFormContext();

  const value = useCpFormValue(`opaque.payload`);

  return (
    <>
      <CardContent>
        <div className="mb-12">
          <div className="flex items-center gap-4 mb-2">
            <div>Opaque Secret Data</div>
            <ImportButtonRaw
              formId={id}
              fieldName="opaque.payload"
              actionLabel="Import opaque secret"
              existingHasContent={!!value?.trim()}
              explanation={
                <div className="text-xs">
                  <div className="font-semibold mb-1">Accepted formats:</div>
                  <div>Any text file content</div>
                  <div className="mt-1 opacity-75">Content will replace existing data</div>
                </div>
              }
            />
          </div>
          <SecretCodeEditorObfuscated visibilityName="meta.codeEditorVisibility.opaque.payload" contentName="opaque.payload">
            <DropZone
              formId={id}
              fieldName="opaque.payload"
              actionLabel="Import opaque secret"
            >
              <CodeEditor
                value={value}
                setValue={(value) => {
                  formSetValue(id, `opaque.payload`, value);
                }}
                onChange={() => {
                  const name = "opaque.payload";
                  formSet(id, `fieldStates.${name}.modified`, true);

                  const form = store.getState().form.instances[id];
                  const onChangeCounter = form.meta.onChangeCounter;
                  formSet(id, `meta.onChangeCounter`, onChangeCounter + 1);
                }}
                onFocus={() => {
                  const name = "opaque.payload";
                  formSet(id, `fieldStates.${name}.focused`, true);
                  formSet(id, `fieldStates.${name}.visited`, true);
                }}
                onBlur={() => {
                  const name = "opaque.payload";
                  formSet(id, `fieldStates.${name}.focused`, false);
                  formSet(id, `fieldStates.${name}.touched`, true);

                  const form = store.getState().form.instances[id];
                  const onBlurCounter = form.meta.onBlurCounter;
                  formSet(id, `meta.onBlurCounter`, onBlurCounter + 1);
                }}
                language={"javascript"}
                options={{
                  basicSetup: {
                    lineNumbers: true,
                  },
                  style: {
                    maxHeight: 500,
                    overflow: "auto",
                    fontSize: 14,
                  },
                }}
              />
            </DropZone>
          </SecretCodeEditorObfuscated>
          <CpErrorWarning name={`opaque.payload`} />
        </div>
        <CpFormItem>
          <div className="flex items-center gap-2">
            <CpLabel name={`opaque.base64Decode`}>Base64 Decode at Runtime</CpLabel>
            <CpSwitch name={`opaque.base64Decode`} />
            <CpTooltip
              tooltipProps={{
                title: `Checking this box will perform a base64 decode at runtime of the secret content.`,
              }}
            />
          </div>
          <CpErrorWarning name={`opaque.base64Decode`} />
        </CpFormItem>
      </CardContent>
    </>
  );
};
